module.exports = __webpack_public_path__ + "static/img/4.b0947d3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Accidentes-personales/4.png
// module id = 4Xpg
// module chunks = 0